// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   GearPage.css — EDUCATE Complete Landing Page
   Brand: #5AAF9A (Emerald Accent), #111111 (Dark Theme), #FFFFFF
   The 5-Stage Civic Empowerment Journey
   ===================================================== */

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Root ── */
.gear-root {
  min-height: 100vh;
  background: #0d0e12;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

/* ── Shared utils ── */
.c-green { color: #5AAF9A; }

.adv-sec {
  padding: 88px clamp(24px, 6vw, 100px);
  position: relative;
}

.adv-sec__hdr {
  text-align: center;
  margin-bottom: 54px;
}

.sec-step-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  border: 1px solid rgba(90, 175, 154, 0.3);
  border-radius: 20px;
  padding: 6px 16px;
  margin-bottom: 16px;
}

.adv-sec__title {
  font-size: clamp(28px, 4vw, 46px);
  font-weight: 900;
  letter-spacing: -0.5px;
  color: #fff;
  margin-bottom: 12px;
  line-height: 1.2;
}

.adv-sec__sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.65);
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.6;
}

/* ── Glass Card Utility ── */
.glass-card {
  background: rgba(18, 22, 28, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
}

/* ── Shared button ── */
.gr-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 28px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  transition: transform 0.18s, box-shadow 0.18s, opacity 0.18s, background 0.18s;
  white-space: nowrap;
  font-family: inherit;
}
.gr-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,0.4); }
.gr-btn:active { transform: translateY(0); }

.gr-btn--pink {
  background: #5AAF9A;
  color: #fff;
  box-shadow: 0 4px 18px rgba(90, 175, 154, 0.35);
}
.gr-btn--pink:hover { opacity: 0.92; box-shadow: 0 8px 28px rgba(90, 175, 154, 0.5); }

.gr-btn--outline {
  background: transparent;
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.3);
}
.gr-btn--outline:hover { background: rgba(255, 255, 255, 0.07); border-color: rgba(255, 255, 255, 0.55); }

/* =============================================================
   1. NAVBAR
   ============================================================= */
.gn {
  position: sticky;
  top: 0;
  z-index: 990;
  background: rgba(13, 14, 18, 0.75);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  display: flex;
  align-items: center;
  padding: 0 clamp(20px, 4vw, 56px);
  min-height: 72px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background 0.3s, box-shadow 0.3s;
}
.gn--scrolled {
  background: rgba(13, 14, 18, 0.96);
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.6);
}

.gn__logo {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 32px;
  padding: 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.gn__logo:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.gn__logo-img {
  height: clamp(42px, 3.2vw, 56px);
  width: auto;
  object-fit: contain;
  display: block;
}

.gn__brand-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(90, 175, 154, 0.1);
  border: 1px solid rgba(90, 175, 154, 0.25);
  border-radius: 20px;
  padding: 4px 10px;
}

.gn__logo-icon {
  font-size: 15px;
  line-height: 1;
}

.gn__logo-word {
  font-size: 13.5px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: #fff;
}

.gn__links {
  display: flex;
  align-items: center;
  gap: 6px;
  list-style: none;
}
.gn__link {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  font-size: 13.5px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 20px;
  cursor: pointer;
  transition: color 0.18s, background 0.18s;
  font-family: inherit;
  white-space: nowrap;
}
.gn__link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.07);
}

.gn__right {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}
.gn__ghost {
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  color: rgba(255, 255, 255, 0.85);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 22px;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;
  white-space: nowrap;
}
.gn__ghost:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.38);
}

.gn__icon {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  transition: background 0.15s;
}
.gn__icon:hover { background: rgba(255, 255, 255, 0.08); }

.gn__back-hub {
  background: transparent;
  border: 1px solid rgba(90, 175, 154, 0.55);
  border-radius: 20px;
  padding: 6px 15px;
  font-size: 12px;
  font-weight: 600;
  color: #5AAF9A;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}
.gn__back-hub:hover {
  background: rgba(90, 175, 154, 0.15);
  border-color: #5AAF9A;
}

.gn__hamburger {
  display: none;
  background: none;
  border: none;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
}

/* Mobile drawer */
.gn__overlay {
  position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); z-index: 1100;
}
.gn__drawer {
  position: fixed;
  top: 0; right: 0;
  width: 280px; height: 100%;
  background: #14171f;
  z-index: 1200;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(.4, 0, .2, 1);
}
.gn__drawer--open { transform: translateX(0); }
.gn__drawer-close {
  background: none; border: none; color: #fff; font-size: 20px; cursor: pointer;
  align-self: flex-end; margin-bottom: 8px; padding: 4px 8px; border-radius: 6px;
}
.gn__drawer-link {
  background: none; border: none; color: rgba(255, 255, 255, 0.85);
  font-size: 15px; font-weight: 600; padding: 12px 10px; cursor: pointer;
  text-align: left; border-radius: 8px; font-family: inherit;
  transition: background 0.15s, color 0.15s;
}
.gn__drawer-link:hover { background: rgba(90, 175, 154, 0.12); color: #5AAF9A; }

/* =============================================================
   2. HERO (STAGE 1: EDUCATE)
   ============================================================= */
.gh {
  min-height: calc(100vh - 64px);
  background: #0a0b0e;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.gh__bg-img {
  position: absolute;
  inset: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: center center;
  z-index: 0;
  filter: brightness(1.15);
}
.gh__bg-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(to right, rgba(10, 11, 14, 0.85) 30%, rgba(10, 11, 14, 0.5) 65%, rgba(10, 11, 14, 0.25) 100%),
    linear-gradient(to top, rgba(10, 11, 14, 0.8) 0%, transparent 40%);
}
.gh__content {
  position: relative; z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  padding: 80px clamp(24px, 6vw, 100px);
  width: 100%;
}
.gh__left {
  flex: 1.2 1;
  display: flex;
  flex-direction: column;
  gap: 22px;
  max-width: 660px;
}
.gh__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  letter-spacing: 2.5px;
  color: #5AAF9A;
  font-weight: 800;
}
.gh__title {
  font-size: clamp(40px, 5.8vw, 76px);
  font-weight: 900;
  line-height: 1.05;
  letter-spacing: -1px;
  color: #fff;
}
.gh__sub {
  font-size: 16.5px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.7;
}
.gh__ctas {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 6px;
}

/* Hero Right Video Teaser Card */
.gh__right {
  flex: 0.9 1;
  display: flex;
  justify-content: flex-end;
}
.gh-video-card {
  position: relative;
  width: 100%;
  max-width: 440px;
  background: rgba(18, 22, 30, 0.75);
  border: 1px solid rgba(90, 175, 154, 0.35);
  border-radius: 20px;
  padding: 16px;
  cursor: pointer;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5), 0 0 30px rgba(90, 175, 154, 0.15);
  transition: transform 0.25s ease, border-color 0.25s, box-shadow 0.25s;
  backdrop-filter: blur(12px);
}
.gh-video-card:hover {
  transform: translateY(-6px);
  border-color: #5AAF9A;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6), 0 0 45px rgba(90, 175, 154, 0.3);
}
.gh-video-card__thumb {
  position: relative;
  width: 100%;
  height: 230px;
  border-radius: 14px;
  background: linear-gradient(135deg, #101e28 0%, #0d121b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.gh-video-card__play {
  width: 68px; height: 68px;
  border-radius: 50%;
  background: #5AAF9A;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 0 28px rgba(90, 175, 154, 0.6);
  transition: transform 0.2s, background 0.2s;
}
.gh-video-card:hover .gh-video-card__play {
  transform: scale(1.12);
  background: #2DAA6E;
}
.gh-video-card__play-triangle {
  margin-left: 4px;
}
.gh-video-badge {
  position: absolute;
  top: 14px; left: 14px;
  background: rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
}
.gh-video-dot {
  width: 7px; height: 7px; border-radius: 50%; background: #5AAF9A;
  box-shadow: 0 0 8px #5AAF9A;
}
.gh-video-dur {
  position: absolute;
  bottom: 12px; right: 12px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
}
.gh-video-card__info {
  margin-top: 14px;
}
.gh-video-card__info h4 {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}
.gh-video-card__info p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

/* =============================================================
   3. STAGE 2: POST TRUTHS (SHORT VIDEOS)
   ============================================================= */
.gpt-sec {
  background: #0d0f14;
}
.gpt-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 22px;
  margin-top: 36px;
}
.gpt-card {
  background: rgba(15, 19, 26, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 480px;
  position: relative;
}
.gpt-card:hover {
  transform: translateY(-6px);
  border-color: rgba(90, 175, 154, 0.6);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.55), 0 0 20px rgba(90, 175, 154, 0.2);
}
.gpt-card--active {
  border-color: #5AAF9A;
  box-shadow: 0 0 28px rgba(90, 175, 154, 0.3);
}

/* Visual / Video container takes ~70% of card */
.gpt-card__visual {
  position: relative;
  flex: 0 0 68%;
  height: 68%;
  background: #080b10;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gpt-card__media-img,
.gpt-card__media-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}
.gpt-card:hover .gpt-card__media-img,
.gpt-card:hover .gpt-card__media-video {
  transform: scale(1.04);
}
.gpt-card__media-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #111923 0%, #080d14 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Floating top badges over video */
.gpt-card__floating-top {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  pointer-events: none;
}
.gpt-card__category {
  font-size: 11px;
  font-weight: 700;
  border-radius: 20px;
  border: 1px solid;
  padding: 3px 10px;
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.6);
}
.gpt-card__duration {
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  padding: 2px 8px;
  border-radius: 12px;
}

.gpt-card__play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  border: 1.5px solid rgba(255, 255, 255, 0.85);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: transform 0.25s ease, background 0.25s ease, opacity 0.25s ease;
  z-index: 3;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.gpt-card:hover .gpt-card__play-icon {
  transform: translate(-50%, -50%) scale(1.12);
  background: #5AAF9A;
  border-color: #5AAF9A;
  color: #0d0f14;
}

.gpt-card__play-icon--playing {
  opacity: 0;
  pointer-events: none;
}
.gpt-card:hover .gpt-card__play-icon--playing {
  opacity: 0.85;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.7);
  border-color: rgba(255, 255, 255, 0.7);
  color: #fff;
}
.gpt-card:hover .gpt-card__play-icon--playing:hover {
  opacity: 1;
  background: #e11d48;
  border-color: #e11d48;
}

.gpt-card__sound-btn {
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  pointer-events: auto;
  transition: transform 0.2s, background 0.2s;
}
.gpt-card__sound-btn:hover {
  transform: scale(1.15);
  background: #5AAF9A;
  color: #0d0f14;
  border-color: #5AAF9A;
}

.gpt-card__feed-btn {
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(90, 175, 154, 0.5);
  color: #5AAF9A;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  cursor: pointer;
  pointer-events: auto;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}
.gpt-card__feed-btn:hover {
  background: #5AAF9A;
  color: #0d0f14;
}

.gpt-card__scrim {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0.25) 60%, transparent 100%);
  pointer-events: none;
  z-index: 2;
}

.gpt-card__overlay-tag {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 3;
  pointer-events: none;
}

.gpt-card__stat-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  padding: 3px 8px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* Bottom content container taking ~30% of card */
.gpt-card__body {
  flex: 0 0 32%;
  height: 32%;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgba(18, 22, 28, 0.98);
}
.gpt-card__author-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}
.gpt-card__avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #5AAF9A;
  color: #0d0f14;
  font-size: 10.5px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gpt-card__avatar-img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.gpt-card__author {
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gpt-card__city {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  display: block;
}
.gpt-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  margin: 2px 0;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gpt-card__desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.35;
  margin: 2px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gpt-card__footer {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 6px;
  margin-top: auto;
}
.gpt-linked-tag {
  font-size: 11px;
  font-weight: 600;
  color: #5AAF9A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.gpt-actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 44px;
}

/* =============================================================
   4. STAGE 3: CREATE SOLUTIONS (MATE ADD BALLOT)
   ============================================================= */
.gcs-sec {
  background: #090b10;
}
.gcs-container {
  display: grid;
  grid-template-columns: 1.25fr 0.95fr;
  gap: 36px;
  margin-top: 36px;
  align-items: stretch;
}
.gcs-chat {
  padding: 24px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(90, 175, 154, 0.25);
  background: rgba(14, 18, 24, 0.8);
  height: 100%;
  box-sizing: border-box;
}
.gcs-chat__hdr {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.gcs-chat__mate-avatar {
  position: relative;
  width: 42px; height: 42px;
  border-radius: 50%;
  background: rgba(90, 175, 154, 0.2);
  border: 1px solid #5AAF9A;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px;
}
.gcs-online-dot {
  position: absolute;
  bottom: 0; right: 0;
  width: 9px; height: 9px;
  border-radius: 50%;
  background: #2DAA6E;
  border: 2px solid #141820;
}
.gcs-chat__hdr strong {
  font-size: 15px; color: #fff; display: block;
}
.gcs-chat__hdr span {
  font-size: 12px; color: rgba(255, 255, 255, 0.5); display: block;
}
.gcs-badge-live {
  margin-left: auto;
  font-size: 11px;
  font-weight: 700;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  padding: 3px 10px;
  border-radius: 12px;
}
.gcs-chat__body {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
}
.gcs-msg {
  display: flex;
  flex-direction: column;
}
.gcs-msg__lbl {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 4px;
}
.gcs-bubble {
  padding: 12px 16px;
  border-radius: 14px;
  font-size: 13.5px;
  line-height: 1.55;
  max-width: 90%;
}
.gcs-bubble--user {
  align-self: flex-start;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.gcs-bubble--mate {
  align-self: flex-start;
  background: rgba(90, 175, 154, 0.14);
  color: #fff;
  border: 1px solid rgba(90, 175, 154, 0.3);
}
.gcs-ballot-card {
  margin: 8px 0;
  background: #1e2528;
  border: 1px solid rgba(0, 224, 197, 0.5);
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.gcs-ballot-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.gcs-ballot-num {
  font-size: 11px;
  font-weight: 800;
  color: #00e0c5;
  letter-spacing: 0.5px;
}
.gcs-ballot-status {
  font-size: 10.5px;
  font-weight: 700;
  color: #00e0c5;
  background: rgba(0, 224, 197, 0.12);
  border: 1px solid rgba(0, 224, 197, 0.5);
  padding: 2px 8px;
  border-radius: 999px;
}
.gcs-ballot-card h4 {
  font-size: 14.5px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 6px;
  line-height: 1.35;
}
.gcs-ballot-card p {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.45;
  margin-bottom: 12px;
}
.gcs-ballot-options-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 10px 0 14px 0;
}
.gcs-ballot-option {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 7px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #e2e8f0;
}
.gcs-option-bullet {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(0, 224, 197, 0.15);
  border: 1px solid rgba(0, 224, 197, 0.4);
  color: #00e0c5;
  font-size: 10px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gcs-ballot-card__actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 12px;
}
.gcs-keep-ballot-btn {
  background: rgba(0, 224, 197, 0.15);
  color: #00e0c5;
  border: 1px solid rgba(0, 224, 197, 0.7);
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}
.gcs-keep-ballot-btn:hover {
  background: #00e0c5;
  color: #0d1117;
  box-shadow: 0 4px 14px rgba(0, 224, 197, 0.35);
}
.gcs-chat__input-row {
  display: flex;
  gap: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 16px;
  margin-top: auto;
}
.gcs-mock-input {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 10px 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12.5px;
  outline: none;
  cursor: pointer;
}
.gcs-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  box-sizing: border-box;
}
.gcs-feat-card {
  display: flex;
  gap: 16px;
  padding: 20px 22px;
  background: rgba(18, 22, 28, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  transition: border-color 0.2s, transform 0.2s;
  flex: 1 1;
  align-items: center;
}
.gcs-feat-card:hover {
  border-color: rgba(90, 175, 154, 0.4);
  transform: translateX(4px);
}
.gcs-feat-icon {
  font-size: 26px;
  flex-shrink: 0;
}
.gcs-feat-card h4 {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}
.gcs-feat-card p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
}
.gcs-actions-box {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gcs-actions-box .gr-btn {
  width: 100%;
  justify-content: center;
}

/* =============================================================
   5. STAGE 4: STUDY THE DATA (PROBLEM CATALOGUE & SEQUENCES)
   ============================================================= */
.gsd-sec {
  background: #0b0d12;
}
.gsd-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
  margin-bottom: 32px;
}
.gsd-metric-card {
  background: rgba(18, 22, 30, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, border-color 0.2s;
}
.gsd-metric-card:hover {
  transform: translateY(-4px);
  border-color: rgba(90, 175, 154, 0.4);
}
.gsd-metric-icon { font-size: 24px; margin-bottom: 8px; }
.gsd-metric-val {
  font-size: 28px;
  font-weight: 900;
  color: #fff;
  letter-spacing: -0.5px;
}
.gsd-metric-lbl {
  font-size: 13.5px;
  font-weight: 700;
  color: #5AAF9A;
  margin: 4px 0 2px;
}
.gsd-metric-sub {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.5);
}

/* Sequence visualizer line */
.gsd-sequence-tracker {
  padding: 22px 28px;
  margin-bottom: 32px;
  background: rgba(18, 22, 30, 0.6);
  border: 1px solid rgba(90, 175, 154, 0.25);
}
.gsd-tracker-hdr {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  font-size: 13px;
}
.gsd-tracker-hdr strong { color: #5AAF9A; }
.gsd-tracker-hdr span { color: rgba(255, 255, 255, 0.5); }
.gsd-steps-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
}
.gsd-step {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}
.gsd-step.active {
  border-color: #5AAF9A;
  background: rgba(90, 175, 154, 0.12);
  color: #fff;
}
.gsd-step-num {
  width: 20px; height: 20px;
  border-radius: 50%;
  background: #5AAF9A;
  color: #000;
  font-size: 11px;
  font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.gsd-arrow {
  color: rgba(90, 175, 154, 0.6);
  font-weight: 700;
}

/* Problem Catalogue Dashboard */
.gsd-dashboard {
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.gsd-dash-hdr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}
.gsd-dept-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.gsd-tab {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.18s;
  font-family: inherit;
}
.gsd-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.gsd-tab--active {
  background: #5AAF9A;
  border-color: #5AAF9A;
  color: #fff;
}
.gsd-search-input {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 12.5px;
  color: #fff;
  width: 240px;
  outline: none;
}
.gsd-search-input:focus {
  border-color: #5AAF9A;
}

/* Table styles */
.gsd-table-wrapper {
  overflow-x: auto;
}
.gsd-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 13px;
}
.gsd-table th {
  padding: 12px 14px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.gsd-table td {
  padding: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  vertical-align: middle;
}
.gsd-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.02);
}
.gsd-dept-col {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gsd-dept-icon { font-size: 20px; }
.gsd-dept-col strong { color: #fff; display: block; font-size: 12.5px; }
.gsd-dept-col span { color: rgba(255, 255, 255, 0.5); font-size: 11px; display: block; }

.gsd-title-col strong { color: #fff; display: block; font-size: 13.5px; margin-bottom: 2px; }
.gsd-ballot-link { color: #5AAF9A; font-size: 11px; font-weight: 600; }

.gsd-city-tag { color: rgba(255, 255, 255, 0.65); font-size: 12px; }

.gsd-stage-col { display: flex; flex-direction: column; gap: 3px; }
.gsd-stage-badge {
  display: inline-block;
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  width: fit-content;
}
.stage--1 { background: rgba(255, 255, 255, 0.1); color: #fff; }
.stage--2 { background: rgba(46, 111, 216, 0.2); color: #2E6FD8; }
.stage--3 { background: rgba(245, 166, 35, 0.2); color: #F5A623; }
.stage--4 { background: rgba(90, 175, 154, 0.2); color: #5AAF9A; }
.stage--5 { background: rgba(45, 170, 110, 0.2); color: #2DAA6E; }

.gsd-stage-col small { font-size: 10px; color: rgba(255, 255, 255, 0.4); }
.gsd-fund-tag {
  font-size: 13px; font-weight: 700; color: #2DAA6E;
  background: rgba(45, 170, 110, 0.1); padding: 4px 10px; border-radius: 8px;
}

/* =============================================================
   6. STAGE 5: GET CERTIFIED (DECENTRALIZED ACCREDITATION)
   ============================================================= */
.gpr {
  background: #0d0f14;
}
.gpr__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}
.gpr__card {
  background: rgba(18, 22, 28, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: transform 0.22s, border-color 0.22s, box-shadow 0.22s;
}
.gpr__card:hover {
  transform: translateY(-5px);
  border-color: rgba(90, 175, 154, 0.4);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.4);
}
.gpr__badge {
  position: absolute;
  top: 16px; right: 16px;
  font-size: 10.5px;
  font-weight: 800;
  text-transform: uppercase;
  color: #fff;
  padding: 3px 9px;
  border-radius: 12px;
}
.gpr__img-wrap {
  width: 58px; height: 58px;
  border-radius: 16px;
  background: rgba(90, 175, 154, 0.15);
  border: 1px solid rgba(90, 175, 154, 0.3);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 16px;
  position: relative;
}
.gpr__emoji { font-size: 28px; }
.gpr__body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.gpr__name {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
  line-height: 1.3;
}
.gpr__desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.55;
  margin-bottom: 14px;
  flex: 1 1;
}
.gpr__rating {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}
.gpr__stars { color: #5AAF9A; font-size: 14px; }
.gpr__rcount { font-size: 11.5px; color: rgba(255, 255, 255, 0.45); }
.gpr__price-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 16px;
}
.gpr__price {
  font-size: 18px;
  font-weight: 800;
  color: #2DAA6E;
}
.gpr__add {
  width: 100%;
}

/* =============================================================
   7. FAQ SECTION
   ============================================================= */
.gfq {
  background: #090b0e;
}
.gfq__list {
  max-width: 820px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gfq__item {
  background: rgba(18, 22, 28, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  overflow: hidden;
  transition: border-color 0.2s;
}
.gfq__item--open {
  border-color: rgba(90, 175, 154, 0.45);
}
.gfq__q {
  width: 100%;
  padding: 18px 22px;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.gfq__chevron {
  font-size: 11px;
  color: #5AAF9A;
}
.gfq__a {
  padding: 0 22px 18px;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.6;
  display: none;
}
.gfq__item--open .gfq__a {
  display: block;
}

/* =============================================================
   8. VIDEO LIGHTBOX MODAL
   ============================================================= */
.gh-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: fadeInModal 0.25s ease;
}
@keyframes fadeInModal {
  from { opacity: 0; }
  to { opacity: 1; }
}
.gh-modal-container {
  position: relative;
  width: 100%;
  max-width: 680px;
  background: #12161f;
  border: 1px solid rgba(90, 175, 154, 0.4);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.7), 0 0 50px rgba(90, 175, 154, 0.2);
}
.gh-modal-close {
  position: absolute;
  top: 16px; right: 16px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: #fff;
  width: 32px; height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.2s;
}
.gh-modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}
.gh-modal-video-box {
  width: 100%;
}
.gh-modal-placeholder {
  text-align: center;
  padding: 20px 10px;
}
.gh-modal-play-icon {
  font-size: 48px;
  margin-bottom: 12px;
}
.gh-modal-placeholder h3 {
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 10px;
}
.gh-modal-placeholder p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto 24px;
}
.gh-modal-steps-preview {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gh-modal-steps-preview span {
  font-size: 11px;
  font-weight: 700;
  color: #5AAF9A;
  background: rgba(90, 175, 154, 0.14);
  border: 1px solid rgba(90, 175, 154, 0.3);
  padding: 4px 10px;
  border-radius: 12px;
}

/* =============================================================
   9. RESPONSIVE BREAKPOINTS
   ============================================================= */
@media (max-width: 1024px) {
  .gh__content {
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
  }
  .gh__right {
    width: 100%;
    justify-content: flex-start;
  }
  .gh-video-card {
    max-width: 100%;
  }
  .gcs-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .gn__links { display: none; }
  .gn__ghost { display: none; }
  .gn__drawer .gn__ghost { display: block; }
  .gn__hamburger { display: flex; }

  .adv-sec { padding: 60px 20px; }
  .gh__content { padding: 60px 20px 40px; }
  .gh__title { font-size: clamp(34px, 8vw, 48px); }

  .gpt-grid { grid-template-columns: 1fr; }
  .gcs-chat { padding: 16px; }
  .gcs-chat__input-row { flex-direction: column; }
  .gsd-steps-line { justify-content: flex-start; }
  .gsd-dash-hdr { flex-direction: column; align-items: stretch; }
  .gsd-search-input { width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/GearPage/GearPage.css"],"names":[],"mappings":"AAAA;;;;0DAI0D;;AAE1D,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,8EAA8E;EAC9E,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB,WAAW,cAAc,EAAE;;AAE3B;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8EAA8E;EAC9E,mBAAmB;EACnB,oBAAoB;AACtB;AACA,gBAAgB,2BAA2B,EAAE,sCAAsC,EAAE;AACrF,iBAAiB,wBAAwB,EAAE;;AAE3C;EACE,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;AACA,sBAAsB,aAAa,EAAE,8CAA8C,EAAE;;AAErF;EACE,uBAAuB;EACvB,WAAW;EACX,0CAA0C;AAC5C;AACA,yBAAyB,qCAAqC,EAAE,uCAAuC,EAAE;;AAEzG;;kEAEkE;AAClE;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,kDAAkD;EAClD,4CAA4C;AAC9C;AACA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA,kBAAkB,qCAAqC,EAAE;;AAEzD;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe,EAAE,QAAQ,EAAE,+BAA+B,EAAE,aAAa;AAC3E;AACA;EACE,eAAe;EACf,MAAM,EAAE,QAAQ;EAChB,YAAY,EAAE,YAAY;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,qDAAqD;AACvD;AACA,oBAAoB,wBAAwB,EAAE;AAC9C;EACE,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,eAAe,EAAE,eAAe;EAC7E,oBAAoB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;AAChF;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,gCAAgC;EAChE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;EACtE,gBAAgB,EAAE,kBAAkB,EAAE,oBAAoB;EAC1D,yCAAyC;AAC3C;AACA,yBAAyB,oCAAoC,EAAE,cAAc,EAAE;;AAE/E;;kEAEkE;AAClE;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,YAAY;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;sEAEoE;AACtE;AACA;EACE,kBAAkB,EAAE,UAAU;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,WAAS;EACT,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,6EAA6E;EAC7E,sEAAsE;EACtE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;EAC5C,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,UAAU;EACrB,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB;EAChE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,YAAY,EAAE,WAAW;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;kEAEkE;AAClE;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,gFAAgF;EAChF,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6EAA6E;AAC/E;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,6CAA6C;EAC7C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2EAA2E;EAC3E,UAAU;EACV,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sGAAsG;EACtG,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;kEAEkE;AAClE;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,iCAAiC;EACjC,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,QAAQ;EACnB,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe,EAAE,WAAW,EAAE,cAAc;AAC9C;AACA;EACE,eAAe,EAAE,+BAA+B,EAAE,cAAc;AAClE;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,6CAA6C;EAC7C,SAAO;EACP,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;;kEAEkE;AAClE;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;AACA,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;AACxD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA,0BAA0B,cAAc,EAAE;AAC1C,wBAAwB,+BAA+B,EAAE;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC7D;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,sBAAsB;AACxB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA,iBAAiB,eAAe,EAAE;AAClC,uBAAuB,WAAW,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACvE,qBAAqB,+BAA+B,EAAE,eAAe,EAAE,cAAc,EAAE;;AAEvF,wBAAwB,WAAW,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC5F,mBAAmB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEtE,gBAAgB,gCAAgC,EAAE,eAAe,EAAE;;AAEnE,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,YAAY,oCAAoC,EAAE,WAAW,EAAE;AAC/D,YAAY,mCAAmC,EAAE,cAAc,EAAE;AACjE,YAAY,mCAAmC,EAAE,cAAc,EAAE;AACjE,YAAY,mCAAmC,EAAE,cAAc,EAAE;AACjE,YAAY,mCAAmC,EAAE,cAAc,EAAE;;AAEjE,uBAAuB,eAAe,EAAE,+BAA+B,EAAE;AACzE;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,mCAAmC,EAAE,iBAAiB,EAAE,kBAAkB;AAC5E;;AAEA;;kEAEkE;AAClE;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iEAAiE;AACnE;AACA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;AACA,cAAc,eAAe,EAAE;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,SAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA,cAAc,cAAc,EAAE,eAAe,EAAE;AAC/C,eAAe,iBAAiB,EAAE,gCAAgC,EAAE;AACpE;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;;kEAEkE;AAClE;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;;kEAEkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,4EAA4E;AAC9E;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,2BAA2B;AAC7B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;kEAEkE;AAClE;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa,aAAa,EAAE;EAC5B,aAAa,aAAa,EAAE;EAC5B,yBAAyB,cAAc,EAAE;EACzC,iBAAiB,aAAa,EAAE;;EAEhC,WAAW,kBAAkB,EAAE;EAC/B,eAAe,uBAAuB,EAAE;EACxC,aAAa,iCAAiC,EAAE;;EAEhD,YAAY,0BAA0B,EAAE;EACxC,YAAY,aAAa,EAAE;EAC3B,uBAAuB,sBAAsB,EAAE;EAC/C,kBAAkB,2BAA2B,EAAE;EAC/C,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;EAC9D,oBAAoB,WAAW,EAAE;AACnC","sourcesContent":["/* =====================================================\n   GearPage.css — EDUCATE Complete Landing Page\n   Brand: #5AAF9A (Emerald Accent), #111111 (Dark Theme), #FFFFFF\n   The 5-Stage Civic Empowerment Journey\n   ===================================================== */\n\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n/* ── Root ── */\n.gear-root {\n  min-height: 100vh;\n  background: #0d0e12;\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n}\n\n/* ── Shared utils ── */\n.c-green { color: #5AAF9A; }\n\n.adv-sec {\n  padding: 88px clamp(24px, 6vw, 100px);\n  position: relative;\n}\n\n.adv-sec__hdr {\n  text-align: center;\n  margin-bottom: 54px;\n}\n\n.sec-step-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 2.5px;\n  text-transform: uppercase;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  border-radius: 20px;\n  padding: 6px 16px;\n  margin-bottom: 16px;\n}\n\n.adv-sec__title {\n  font-size: clamp(28px, 4vw, 46px);\n  font-weight: 900;\n  letter-spacing: -0.5px;\n  color: #fff;\n  margin-bottom: 12px;\n  line-height: 1.2;\n}\n\n.adv-sec__sub {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.65);\n  max-width: 720px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* ── Glass Card Utility ── */\n.glass-card {\n  background: rgba(18, 22, 28, 0.7);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 18px;\n}\n\n/* ── Shared button ── */\n.gr-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 28px;\n  font-size: 14px;\n  font-weight: 700;\n  border-radius: 30px;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.18s, box-shadow 0.18s, opacity 0.18s, background 0.18s;\n  white-space: nowrap;\n  font-family: inherit;\n}\n.gr-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,0.4); }\n.gr-btn:active { transform: translateY(0); }\n\n.gr-btn--pink {\n  background: #5AAF9A;\n  color: #fff;\n  box-shadow: 0 4px 18px rgba(90, 175, 154, 0.35);\n}\n.gr-btn--pink:hover { opacity: 0.92; box-shadow: 0 8px 28px rgba(90, 175, 154, 0.5); }\n\n.gr-btn--outline {\n  background: transparent;\n  color: #fff;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n.gr-btn--outline:hover { background: rgba(255, 255, 255, 0.07); border-color: rgba(255, 255, 255, 0.55); }\n\n/* =============================================================\n   1. NAVBAR\n   ============================================================= */\n.gn {\n  position: sticky;\n  top: 0;\n  z-index: 990;\n  background: rgba(13, 14, 18, 0.75);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  display: flex;\n  align-items: center;\n  padding: 0 clamp(20px, 4vw, 56px);\n  min-height: 72px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  transition: background 0.3s, box-shadow 0.3s;\n}\n.gn--scrolled {\n  background: rgba(13, 14, 18, 0.96);\n  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.6);\n}\n\n.gn__logo {\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-right: 32px;\n  padding: 0;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.gn__logo:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.gn__logo-img {\n  height: clamp(42px, 3.2vw, 56px);\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.gn__brand-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(90, 175, 154, 0.1);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  border-radius: 20px;\n  padding: 4px 10px;\n}\n\n.gn__logo-icon {\n  font-size: 15px;\n  line-height: 1;\n}\n\n.gn__logo-word {\n  font-size: 13.5px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n  color: #fff;\n}\n\n.gn__links {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  list-style: none;\n}\n.gn__link {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 13.5px;\n  font-weight: 600;\n  padding: 8px 14px;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: color 0.18s, background 0.18s;\n  font-family: inherit;\n  white-space: nowrap;\n}\n.gn__link:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.gn__right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n.gn__ghost {\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  color: rgba(255, 255, 255, 0.85);\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 22px;\n  cursor: pointer;\n  transition: background 0.18s, border-color 0.18s;\n  white-space: nowrap;\n}\n.gn__ghost:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.38);\n}\n\n.gn__icon {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.85);\n  transition: background 0.15s;\n}\n.gn__icon:hover { background: rgba(255, 255, 255, 0.08); }\n\n.gn__back-hub {\n  background: transparent;\n  border: 1px solid rgba(90, 175, 154, 0.55);\n  border-radius: 20px;\n  padding: 6px 15px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #5AAF9A;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, border-color 0.2s, color 0.2s;\n}\n.gn__back-hub:hover {\n  background: rgba(90, 175, 154, 0.15);\n  border-color: #5AAF9A;\n}\n\n.gn__hamburger {\n  display: none;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n}\n\n/* Mobile drawer */\n.gn__overlay {\n  position: fixed; inset: 0; background: rgba(0, 0, 0, 0.65); z-index: 1100;\n}\n.gn__drawer {\n  position: fixed;\n  top: 0; right: 0;\n  width: 280px; height: 100%;\n  background: #14171f;\n  z-index: 1200;\n  padding: 28px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(.4, 0, .2, 1);\n}\n.gn__drawer--open { transform: translateX(0); }\n.gn__drawer-close {\n  background: none; border: none; color: #fff; font-size: 20px; cursor: pointer;\n  align-self: flex-end; margin-bottom: 8px; padding: 4px 8px; border-radius: 6px;\n}\n.gn__drawer-link {\n  background: none; border: none; color: rgba(255, 255, 255, 0.85);\n  font-size: 15px; font-weight: 600; padding: 12px 10px; cursor: pointer;\n  text-align: left; border-radius: 8px; font-family: inherit;\n  transition: background 0.15s, color 0.15s;\n}\n.gn__drawer-link:hover { background: rgba(90, 175, 154, 0.12); color: #5AAF9A; }\n\n/* =============================================================\n   2. HERO (STAGE 1: EDUCATE)\n   ============================================================= */\n.gh {\n  min-height: calc(100vh - 64px);\n  background: #0a0b0e;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.gh__bg-img {\n  position: absolute;\n  inset: 0;\n  width: 100%; height: 100%;\n  object-fit: cover;\n  object-position: center center;\n  z-index: 0;\n  filter: brightness(1.15);\n}\n.gh__bg-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background:\n    linear-gradient(to right, rgba(10, 11, 14, 0.85) 30%, rgba(10, 11, 14, 0.5) 65%, rgba(10, 11, 14, 0.25) 100%),\n    linear-gradient(to top, rgba(10, 11, 14, 0.8) 0%, transparent 40%);\n}\n.gh__content {\n  position: relative; z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 50px;\n  padding: 80px clamp(24px, 6vw, 100px);\n  width: 100%;\n}\n.gh__left {\n  flex: 1.2;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  max-width: 660px;\n}\n.gh__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  letter-spacing: 2.5px;\n  color: #5AAF9A;\n  font-weight: 800;\n}\n.gh__title {\n  font-size: clamp(40px, 5.8vw, 76px);\n  font-weight: 900;\n  line-height: 1.05;\n  letter-spacing: -1px;\n  color: #fff;\n}\n.gh__sub {\n  font-size: 16.5px;\n  color: rgba(255, 255, 255, 0.72);\n  line-height: 1.7;\n}\n.gh__ctas {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n/* Hero Right Video Teaser Card */\n.gh__right {\n  flex: 0.9;\n  display: flex;\n  justify-content: flex-end;\n}\n.gh-video-card {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  background: rgba(18, 22, 30, 0.75);\n  border: 1px solid rgba(90, 175, 154, 0.35);\n  border-radius: 20px;\n  padding: 16px;\n  cursor: pointer;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5), 0 0 30px rgba(90, 175, 154, 0.15);\n  transition: transform 0.25s ease, border-color 0.25s, box-shadow 0.25s;\n  backdrop-filter: blur(12px);\n}\n.gh-video-card:hover {\n  transform: translateY(-6px);\n  border-color: #5AAF9A;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6), 0 0 45px rgba(90, 175, 154, 0.3);\n}\n.gh-video-card__thumb {\n  position: relative;\n  width: 100%;\n  height: 230px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #101e28 0%, #0d121b 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n.gh-video-card__play {\n  width: 68px; height: 68px;\n  border-radius: 50%;\n  background: #5AAF9A;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  box-shadow: 0 0 28px rgba(90, 175, 154, 0.6);\n  transition: transform 0.2s, background 0.2s;\n}\n.gh-video-card:hover .gh-video-card__play {\n  transform: scale(1.12);\n  background: #2DAA6E;\n}\n.gh-video-card__play-triangle {\n  margin-left: 4px;\n}\n.gh-video-badge {\n  position: absolute;\n  top: 14px; left: 14px;\n  background: rgba(0, 0, 0, 0.65);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 14px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #fff;\n}\n.gh-video-dot {\n  width: 7px; height: 7px; border-radius: 50%; background: #5AAF9A;\n  box-shadow: 0 0 8px #5AAF9A;\n}\n.gh-video-dur {\n  position: absolute;\n  bottom: 12px; right: 12px;\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 8px;\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.9);\n}\n.gh-video-card__info {\n  margin-top: 14px;\n}\n.gh-video-card__info h4 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 4px;\n}\n.gh-video-card__info p {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* =============================================================\n   3. STAGE 2: POST TRUTHS (SHORT VIDEOS)\n   ============================================================= */\n.gpt-sec {\n  background: #0d0f14;\n}\n.gpt-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 22px;\n  margin-top: 36px;\n}\n.gpt-card {\n  background: rgba(15, 19, 26, 0.95);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  overflow: hidden;\n  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 480px;\n  position: relative;\n}\n.gpt-card:hover {\n  transform: translateY(-6px);\n  border-color: rgba(90, 175, 154, 0.6);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.55), 0 0 20px rgba(90, 175, 154, 0.2);\n}\n.gpt-card--active {\n  border-color: #5AAF9A;\n  box-shadow: 0 0 28px rgba(90, 175, 154, 0.3);\n}\n\n/* Visual / Video container takes ~70% of card */\n.gpt-card__visual {\n  position: relative;\n  flex: 0 0 68%;\n  height: 68%;\n  background: #080b10;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gpt-card__media-img,\n.gpt-card__media-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s ease;\n}\n.gpt-card:hover .gpt-card__media-img,\n.gpt-card:hover .gpt-card__media-video {\n  transform: scale(1.04);\n}\n.gpt-card__media-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #111923 0%, #080d14 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Floating top badges over video */\n.gpt-card__floating-top {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 2;\n  pointer-events: none;\n}\n.gpt-card__category {\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 20px;\n  border: 1px solid;\n  padding: 3px 10px;\n  backdrop-filter: blur(8px);\n  background: rgba(0, 0, 0, 0.6);\n}\n.gpt-card__duration {\n  font-size: 11px;\n  font-weight: 600;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  padding: 2px 8px;\n  border-radius: 12px;\n}\n\n.gpt-card__play-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(8px);\n  border: 1.5px solid rgba(255, 255, 255, 0.85);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: transform 0.25s ease, background 0.25s ease, opacity 0.25s ease;\n  z-index: 3;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n}\n.gpt-card:hover .gpt-card__play-icon {\n  transform: translate(-50%, -50%) scale(1.12);\n  background: #5AAF9A;\n  border-color: #5AAF9A;\n  color: #0d0f14;\n}\n\n.gpt-card__play-icon--playing {\n  opacity: 0;\n  pointer-events: none;\n}\n.gpt-card:hover .gpt-card__play-icon--playing {\n  opacity: 0.85;\n  pointer-events: auto;\n  background: rgba(0, 0, 0, 0.7);\n  border-color: rgba(255, 255, 255, 0.7);\n  color: #fff;\n}\n.gpt-card:hover .gpt-card__play-icon--playing:hover {\n  opacity: 1;\n  background: #e11d48;\n  border-color: #e11d48;\n}\n\n.gpt-card__sound-btn {\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  cursor: pointer;\n  pointer-events: auto;\n  transition: transform 0.2s, background 0.2s;\n}\n.gpt-card__sound-btn:hover {\n  transform: scale(1.15);\n  background: #5AAF9A;\n  color: #0d0f14;\n  border-color: #5AAF9A;\n}\n\n.gpt-card__feed-btn {\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(90, 175, 154, 0.5);\n  color: #5AAF9A;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  pointer-events: auto;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.gpt-card__feed-btn:hover {\n  background: #5AAF9A;\n  color: #0d0f14;\n}\n\n.gpt-card__scrim {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.72) 0%, rgba(0, 0, 0, 0.25) 60%, transparent 100%);\n  pointer-events: none;\n  z-index: 2;\n}\n\n.gpt-card__overlay-tag {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  right: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 3;\n  pointer-events: none;\n}\n\n.gpt-card__stat-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  padding: 3px 8px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* Bottom content container taking ~30% of card */\n.gpt-card__body {\n  flex: 0 0 32%;\n  height: 32%;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: rgba(18, 22, 28, 0.98);\n}\n.gpt-card__author-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 2px;\n}\n.gpt-card__avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #5AAF9A;\n  color: #0d0f14;\n  font-size: 10.5px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gpt-card__avatar-img {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n.gpt-card__author {\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gpt-card__city {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.5);\n  display: block;\n}\n.gpt-card__title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  margin: 2px 0;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gpt-card__desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.35;\n  margin: 2px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.gpt-card__footer {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 6px;\n  margin-top: auto;\n}\n.gpt-linked-tag {\n  font-size: 11px;\n  font-weight: 600;\n  color: #5AAF9A;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n.gpt-actions {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  margin-top: 44px;\n}\n\n/* =============================================================\n   4. STAGE 3: CREATE SOLUTIONS (MATE ADD BALLOT)\n   ============================================================= */\n.gcs-sec {\n  background: #090b10;\n}\n.gcs-container {\n  display: grid;\n  grid-template-columns: 1.25fr 0.95fr;\n  gap: 36px;\n  margin-top: 36px;\n  align-items: stretch;\n}\n.gcs-chat {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(90, 175, 154, 0.25);\n  background: rgba(14, 18, 24, 0.8);\n  height: 100%;\n  box-sizing: border-box;\n}\n.gcs-chat__hdr {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n.gcs-chat__mate-avatar {\n  position: relative;\n  width: 42px; height: 42px;\n  border-radius: 50%;\n  background: rgba(90, 175, 154, 0.2);\n  border: 1px solid #5AAF9A;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 20px;\n}\n.gcs-online-dot {\n  position: absolute;\n  bottom: 0; right: 0;\n  width: 9px; height: 9px;\n  border-radius: 50%;\n  background: #2DAA6E;\n  border: 2px solid #141820;\n}\n.gcs-chat__hdr strong {\n  font-size: 15px; color: #fff; display: block;\n}\n.gcs-chat__hdr span {\n  font-size: 12px; color: rgba(255, 255, 255, 0.5); display: block;\n}\n.gcs-badge-live {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 700;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  padding: 3px 10px;\n  border-radius: 12px;\n}\n.gcs-chat__body {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n}\n.gcs-msg {\n  display: flex;\n  flex-direction: column;\n}\n.gcs-msg__lbl {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.45);\n  margin-bottom: 4px;\n}\n.gcs-bubble {\n  padding: 12px 16px;\n  border-radius: 14px;\n  font-size: 13.5px;\n  line-height: 1.55;\n  max-width: 90%;\n}\n.gcs-bubble--user {\n  align-self: flex-start;\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n.gcs-bubble--mate {\n  align-self: flex-start;\n  background: rgba(90, 175, 154, 0.14);\n  color: #fff;\n  border: 1px solid rgba(90, 175, 154, 0.3);\n}\n.gcs-ballot-card {\n  margin: 8px 0;\n  background: #1e2528;\n  border: 1px solid rgba(0, 224, 197, 0.5);\n  border-radius: 14px;\n  padding: 18px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n.gcs-ballot-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.gcs-ballot-num {\n  font-size: 11px;\n  font-weight: 800;\n  color: #00e0c5;\n  letter-spacing: 0.5px;\n}\n.gcs-ballot-status {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #00e0c5;\n  background: rgba(0, 224, 197, 0.12);\n  border: 1px solid rgba(0, 224, 197, 0.5);\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n.gcs-ballot-card h4 {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 6px;\n  line-height: 1.35;\n}\n.gcs-ballot-card p {\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.45;\n  margin-bottom: 12px;\n}\n.gcs-ballot-options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 10px 0 14px 0;\n}\n.gcs-ballot-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 7px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #e2e8f0;\n}\n.gcs-option-bullet {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: rgba(0, 224, 197, 0.15);\n  border: 1px solid rgba(0, 224, 197, 0.4);\n  color: #00e0c5;\n  font-size: 10px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gcs-ballot-card__actions {\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 12px;\n}\n.gcs-keep-ballot-btn {\n  background: rgba(0, 224, 197, 0.15);\n  color: #00e0c5;\n  border: 1px solid rgba(0, 224, 197, 0.7);\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.gcs-keep-ballot-btn:hover {\n  background: #00e0c5;\n  color: #0d1117;\n  box-shadow: 0 4px 14px rgba(0, 224, 197, 0.35);\n}\n.gcs-chat__input-row {\n  display: flex;\n  gap: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 16px;\n  margin-top: auto;\n}\n.gcs-mock-input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 24px;\n  padding: 10px 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12.5px;\n  outline: none;\n  cursor: pointer;\n}\n.gcs-features {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: 100%;\n  box-sizing: border-box;\n}\n.gcs-feat-card {\n  display: flex;\n  gap: 16px;\n  padding: 20px 22px;\n  background: rgba(18, 22, 28, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  transition: border-color 0.2s, transform 0.2s;\n  flex: 1;\n  align-items: center;\n}\n.gcs-feat-card:hover {\n  border-color: rgba(90, 175, 154, 0.4);\n  transform: translateX(4px);\n}\n.gcs-feat-icon {\n  font-size: 26px;\n  flex-shrink: 0;\n}\n.gcs-feat-card h4 {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 4px;\n}\n.gcs-feat-card p {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.5;\n}\n.gcs-actions-box {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.gcs-actions-box .gr-btn {\n  width: 100%;\n  justify-content: center;\n}\n\n/* =============================================================\n   5. STAGE 4: STUDY THE DATA (PROBLEM CATALOGUE & SEQUENCES)\n   ============================================================= */\n.gsd-sec {\n  background: #0b0d12;\n}\n.gsd-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 18px;\n  margin-bottom: 32px;\n}\n.gsd-metric-card {\n  background: rgba(18, 22, 30, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s, border-color 0.2s;\n}\n.gsd-metric-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(90, 175, 154, 0.4);\n}\n.gsd-metric-icon { font-size: 24px; margin-bottom: 8px; }\n.gsd-metric-val {\n  font-size: 28px;\n  font-weight: 900;\n  color: #fff;\n  letter-spacing: -0.5px;\n}\n.gsd-metric-lbl {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #5AAF9A;\n  margin: 4px 0 2px;\n}\n.gsd-metric-sub {\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Sequence visualizer line */\n.gsd-sequence-tracker {\n  padding: 22px 28px;\n  margin-bottom: 32px;\n  background: rgba(18, 22, 30, 0.6);\n  border: 1px solid rgba(90, 175, 154, 0.25);\n}\n.gsd-tracker-hdr {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 18px;\n  font-size: 13px;\n}\n.gsd-tracker-hdr strong { color: #5AAF9A; }\n.gsd-tracker-hdr span { color: rgba(255, 255, 255, 0.5); }\n.gsd-steps-line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 6px;\n}\n.gsd-step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 8px 14px;\n  border-radius: 20px;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.7);\n  white-space: nowrap;\n}\n.gsd-step.active {\n  border-color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.12);\n  color: #fff;\n}\n.gsd-step-num {\n  width: 20px; height: 20px;\n  border-radius: 50%;\n  background: #5AAF9A;\n  color: #000;\n  font-size: 11px;\n  font-weight: 800;\n  display: flex; align-items: center; justify-content: center;\n}\n.gsd-arrow {\n  color: rgba(90, 175, 154, 0.6);\n  font-weight: 700;\n}\n\n/* Problem Catalogue Dashboard */\n.gsd-dashboard {\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n.gsd-dash-hdr {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n.gsd-dept-tabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.gsd-tab {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 18px;\n  cursor: pointer;\n  transition: all 0.18s;\n  font-family: inherit;\n}\n.gsd-tab:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n.gsd-tab--active {\n  background: #5AAF9A;\n  border-color: #5AAF9A;\n  color: #fff;\n}\n.gsd-search-input {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  padding: 8px 16px;\n  font-size: 12.5px;\n  color: #fff;\n  width: 240px;\n  outline: none;\n}\n.gsd-search-input:focus {\n  border-color: #5AAF9A;\n}\n\n/* Table styles */\n.gsd-table-wrapper {\n  overflow-x: auto;\n}\n.gsd-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-size: 13px;\n}\n.gsd-table th {\n  padding: 12px 14px;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.45);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n.gsd-table td {\n  padding: 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  vertical-align: middle;\n}\n.gsd-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.02);\n}\n.gsd-dept-col {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.gsd-dept-icon { font-size: 20px; }\n.gsd-dept-col strong { color: #fff; display: block; font-size: 12.5px; }\n.gsd-dept-col span { color: rgba(255, 255, 255, 0.5); font-size: 11px; display: block; }\n\n.gsd-title-col strong { color: #fff; display: block; font-size: 13.5px; margin-bottom: 2px; }\n.gsd-ballot-link { color: #5AAF9A; font-size: 11px; font-weight: 600; }\n\n.gsd-city-tag { color: rgba(255, 255, 255, 0.65); font-size: 12px; }\n\n.gsd-stage-col { display: flex; flex-direction: column; gap: 3px; }\n.gsd-stage-badge {\n  display: inline-block;\n  font-size: 10.5px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  width: fit-content;\n}\n.stage--1 { background: rgba(255, 255, 255, 0.1); color: #fff; }\n.stage--2 { background: rgba(46, 111, 216, 0.2); color: #2E6FD8; }\n.stage--3 { background: rgba(245, 166, 35, 0.2); color: #F5A623; }\n.stage--4 { background: rgba(90, 175, 154, 0.2); color: #5AAF9A; }\n.stage--5 { background: rgba(45, 170, 110, 0.2); color: #2DAA6E; }\n\n.gsd-stage-col small { font-size: 10px; color: rgba(255, 255, 255, 0.4); }\n.gsd-fund-tag {\n  font-size: 13px; font-weight: 700; color: #2DAA6E;\n  background: rgba(45, 170, 110, 0.1); padding: 4px 10px; border-radius: 8px;\n}\n\n/* =============================================================\n   6. STAGE 5: GET CERTIFIED (DECENTRALIZED ACCREDITATION)\n   ============================================================= */\n.gpr {\n  background: #0d0f14;\n}\n.gpr__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n}\n.gpr__card {\n  background: rgba(18, 22, 28, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  transition: transform 0.22s, border-color 0.22s, box-shadow 0.22s;\n}\n.gpr__card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(90, 175, 154, 0.4);\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.4);\n}\n.gpr__badge {\n  position: absolute;\n  top: 16px; right: 16px;\n  font-size: 10.5px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: #fff;\n  padding: 3px 9px;\n  border-radius: 12px;\n}\n.gpr__img-wrap {\n  width: 58px; height: 58px;\n  border-radius: 16px;\n  background: rgba(90, 175, 154, 0.15);\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  display: flex; align-items: center; justify-content: center;\n  margin-bottom: 16px;\n  position: relative;\n}\n.gpr__emoji { font-size: 28px; }\n.gpr__body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.gpr__name {\n  font-size: 17px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 8px;\n  line-height: 1.3;\n}\n.gpr__desc {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.55;\n  margin-bottom: 14px;\n  flex: 1;\n}\n.gpr__rating {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n.gpr__stars { color: #5AAF9A; font-size: 14px; }\n.gpr__rcount { font-size: 11.5px; color: rgba(255, 255, 255, 0.45); }\n.gpr__price-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n.gpr__price {\n  font-size: 18px;\n  font-weight: 800;\n  color: #2DAA6E;\n}\n.gpr__add {\n  width: 100%;\n}\n\n/* =============================================================\n   7. FAQ SECTION\n   ============================================================= */\n.gfq {\n  background: #090b0e;\n}\n.gfq__list {\n  max-width: 820px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.gfq__item {\n  background: rgba(18, 22, 28, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n.gfq__item--open {\n  border-color: rgba(90, 175, 154, 0.45);\n}\n.gfq__q {\n  width: 100%;\n  padding: 18px 22px;\n  background: none;\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n.gfq__chevron {\n  font-size: 11px;\n  color: #5AAF9A;\n}\n.gfq__a {\n  padding: 0 22px 18px;\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.6;\n  display: none;\n}\n.gfq__item--open .gfq__a {\n  display: block;\n}\n\n/* =============================================================\n   8. VIDEO LIGHTBOX MODAL\n   ============================================================= */\n.gh-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: fadeInModal 0.25s ease;\n}\n@keyframes fadeInModal {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n.gh-modal-container {\n  position: relative;\n  width: 100%;\n  max-width: 680px;\n  background: #12161f;\n  border: 1px solid rgba(90, 175, 154, 0.4);\n  border-radius: 20px;\n  padding: 32px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.7), 0 0 50px rgba(90, 175, 154, 0.2);\n}\n.gh-modal-close {\n  position: absolute;\n  top: 16px; right: 16px;\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  color: #fff;\n  width: 32px; height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex; align-items: center; justify-content: center;\n  transition: background 0.2s;\n}\n.gh-modal-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n.gh-modal-video-box {\n  width: 100%;\n}\n.gh-modal-placeholder {\n  text-align: center;\n  padding: 20px 10px;\n}\n.gh-modal-play-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n.gh-modal-placeholder h3 {\n  font-size: 20px;\n  font-weight: 800;\n  color: #fff;\n  margin-bottom: 10px;\n}\n.gh-modal-placeholder p {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.6;\n  max-width: 500px;\n  margin: 0 auto 24px;\n}\n.gh-modal-steps-preview {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.gh-modal-steps-preview span {\n  font-size: 11px;\n  font-weight: 700;\n  color: #5AAF9A;\n  background: rgba(90, 175, 154, 0.14);\n  border: 1px solid rgba(90, 175, 154, 0.3);\n  padding: 4px 10px;\n  border-radius: 12px;\n}\n\n/* =============================================================\n   9. RESPONSIVE BREAKPOINTS\n   ============================================================= */\n@media (max-width: 1024px) {\n  .gh__content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n  }\n  .gh__right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  .gh-video-card {\n    max-width: 100%;\n  }\n  .gcs-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .gn__links { display: none; }\n  .gn__ghost { display: none; }\n  .gn__drawer .gn__ghost { display: block; }\n  .gn__hamburger { display: flex; }\n\n  .adv-sec { padding: 60px 20px; }\n  .gh__content { padding: 60px 20px 40px; }\n  .gh__title { font-size: clamp(34px, 8vw, 48px); }\n\n  .gpt-grid { grid-template-columns: 1fr; }\n  .gcs-chat { padding: 16px; }\n  .gcs-chat__input-row { flex-direction: column; }\n  .gsd-steps-line { justify-content: flex-start; }\n  .gsd-dash-hdr { flex-direction: column; align-items: stretch; }\n  .gsd-search-input { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
